/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from 'components/ConfirmDialog';
import ErrorReporter from 'app/components/ErrorReporter';
import EventTracking from 'lib/EventTracking';
import { ComposerContext } from './SplitComposer/components/ComposerContext';

type Props = {
  orgUuid: ?string,
  orgName: ?string,
  onConfirm: Function,
  onRequestHide: () => void,
  filters: MessageFilterType[],
  totalRecipientCount: number,
};

class SendToDistrictConfirmDialog extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('announcements.composer.confirm_send.view', {
      organization_uuid: this.props.orgUuid,
    });
  }

  render() {
    const { totalRecipientCount, onConfirm, onRequestHide, orgName, orgUuid } = this.props;

    if (!orgUuid) {
      return (
        <ErrorReporter error="Tried to render SendToDistrictConfirmDialog without an orgUuid" />
      );
    }

    if (!orgName) {
      return (
        <ErrorReporter error="Tried to render SendToDistrictConfirmDialog without an orgName" />
      );
    }
    const secondaryText = `This announcement will be sent to ${totalRecipientCount} people in ${orgName}`;
    return (
      <ComposerContext.Consumer>
        {composerContext => (
          <ConfirmDialog
            title={<span>{secondaryText}</span>}
            onConfirm={onConfirm}
            onRequestHide={onRequestHide}
            data-test-selector="visual_composer_send_button"
            actionButtonText="Send"
            confirmEventKey="announcements.composer.confirm_send.schedule.click"
            confirmEventProperties={{
              ...composerContext.getUIEventContext(),
              organization_uuid: orgUuid,
            }}
            cancelButtonText="Cancel"
            cancelEventKey="announcements.composer.confirm_send.cancel.click"
            cancelEventProperties={{
              ...composerContext.getUIEventContext(),
              organization_uuid: orgUuid,
            }}
          />
        )}
      </ComposerContext.Consumer>
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    totalRecipientCount: state.roleBasedMessagingSearch.totalRecipientCount,
  };
};

export { SendToDistrictConfirmDialog };
export default connect(mapStateToProps)(SendToDistrictConfirmDialog);
